import instance from '../scorpiusInstance';
import {
  FETCH_APP_USERS_START,
  FETCH_APP_USERS_SUCCESS,
  FETCH_APP_USERS_ERROR,
} from '../types';

export const fetchAppUsersStart = (orgId, appName) => ({
  type: FETCH_APP_USERS_START,
  orgId,
  appName,
});

export const fetchAppUsersSuccess = (orgId, appName, users) => ({
  type: FETCH_APP_USERS_SUCCESS,
  orgId,
  appName,
  users,
});

export const fetchAppUsersError = (orgId, appName, error) => ({
  type: FETCH_APP_USERS_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Fetch all users for an organization's application.
 * @param {String} orgId
 * @param {String} appName
 * @param {boolean} withUser - When true the current user will be in the list.
 */
export const fetchAppUsers =
  (orgId, appName, withUser = false) =>
  async (dispatch, getState) => {
    dispatch(fetchAppUsersStart(orgId, appName));
    try {
      const { sinatra } = getState();
      const { user } = sinatra;
      const { profile: currentUser } = user;

      const response = await instance.get(
        `/organizations/${orgId}/${appName}/users`,
        { headers: { retry: true } },
      );

      // If `withUser` is true, return all users including the current user.
      // Otherwise, return a filtered list where the current user is excluded.
      // This is to match the default behavior as required in MC-8024, where
      // the list of users being managed should prevent the current user from
      // accidentally editing their own roles.
      let users = response.data;
      if (!withUser) {
        users = response.data.filter(user => user.email !== currentUser.email);
      }

      return dispatch(fetchAppUsersSuccess(orgId, appName, users));
    } catch (error) {
      throw dispatch(fetchAppUsersError(orgId, appName, error));
    }
  };

export default fetchAppUsers;
